module.exports =
{

  _init: function ()
  {
    this.onChangeCompany()
  },

  onChangeCompany: function ()
  {
  
    $('#modal-company_id').not('.js-ignore').change(function ()
    {

      var company_id = parseInt($(this).val(), 10)

      var development = $('#modal-coins_development_id')

      APPLICATION._APPLICATION.loadDropdown(
        development,
        APPLICATION._PATH_PREFIX + 'development/coins-dropdown/' + company_id + '?all=Select...&development_id=' + development.val(),
        'Development',
        'coinsDropdown'
      )

    }
    ).addClass('js-ignore').trigger('change')

  }

}